import {
  Component,
  OnDestroy,
  ViewEncapsulation,
  ViewChild,
  Inject,
  EventEmitter,
  Input,
  Output,
  ElementRef,
  OnInit
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ReplaySubject } from "rxjs";
import { AppService } from "@irb/app.service";
import { ICreateSecurites, SecurityMasterService } from "../security-master/security-master.service";
import { ISecurityCustomCategories, ISecurityCustomCategory } from "../irb-models.model";
import { IrbModelsService } from "../irb-models.service";
import { DataTransferService } from "@irb/irb-common/services/data-transfer.service";
import { UtilityService } from "@irb/irb-common/services/utility.service";
import { IModelManager } from "../models-new/models.service";
import { IrbAppEvents, IrbModelsEvents } from "@irb/irb-common/events";
import { IAlertDialogData } from "@irb/app.model";
import { IDropdownItem } from '@irb-common/models/dropdown.model';

@Component({ standalone: false,
  selector: "irb-create-securities-by-custom-dialog",
  templateUrl: "./create-securities-by-custom-dialog.component.html",
  styleUrls: ["./create-securities-by-custom-dialog.component.scss", "../../irb-common/styles/dialog.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CreateSecuritiesByCustomDialogComponent implements OnDestroy, OnInit {
  @ViewChild('tooltipSucessShow') tooltipSucessShow: ElementRef;
  @ViewChild("securityTypeDropdown") securityTypeDropdown: any;
  @ViewChild("customCategoriesDropdown") customCategoriesDropdown: any;
  securitySymb: string;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  callToActionText: string;
  callBack: Function;
  isOtherInputsDisable: boolean = true;
  canNotContinue: boolean = true;
  parseData: any;
  requestdatas: Array<ICreateSecurites> = [];
  tooltipMessage: string = "";
  tooltipMessageSucess: string = "";
  tooltipMessageSucessShow: boolean = false;
  securitySymbDesc: string;
  selectedCustomCategory: IDropdownItem;
  customCategoryLabel: any;
  public customCategories: Array<ISecurityCustomCategory> = [];
  public customCategoriesDropdownData: Array<IDropdownItem> = [];
  private _selectedCategoryName: string = "Uncategorized";
  securityTypes: Array<IDropdownItem> = [];
  selectedSecurityType: IDropdownItem;
  externalSharePrice: number;
  checkAvailability: boolean = true;
  isExternalShare: boolean = false;
  allowSma:boolean=true;
  updateStatusCount = 0;
  progressTimer: any;
  isUiTest = false;

  constructor(
    public dialogRef: MatDialogRef<CreateSecuritiesByCustomDialogComponent>,
    public securityMasterService: SecurityMasterService,
    public as: AppService,
    private ms: IrbModelsService,
    private dataTransferService: DataTransferService,
    private util: UtilityService,
    @Inject(MAT_DIALOG_DATA) public mdd: any
  ) {  }

  @Output()
    categoryChanged = new EventEmitter<any>();

  @Input()
    set selectedCustomCategoryName(value: string) {
        this._selectedCategoryName = value;
        this.setSelectedCategoryDefaults(value);
    }

    ngOnInit(): void {

      this.ms.getGlobalSettingDetails().subscribe((data: any) => {
        if(data.responseData) {
          this.securityTypes = [
            {value:'GROUP', name:'Group'},
            {value:'OTHER', name:'Other'},
            {value:'SMA', name:'SMA'},
            {value:'EXTERNAL', name:'External'}
          ];
        } else{
          this.securityTypes = [
            {value:'GROUP', name:'Group'},
            {value:'OTHER', name:'Other'},
            {value:'EXTERNAL', name:'External'}
          ];
        }
       
    });
      
      this.ms.getSecuritiesCustomCategories().subscribe((customCategories: ISecurityCustomCategories) => {
          this.customCategories = customCategories.items;
          this.customCategories = this.getDistinctCategories(this.customCategories);
          this.customCategories.forEach((category) => {
            this.customCategoriesDropdownData.push({
              name: category.custCatName,
              value: category.custCatId
            } as IDropdownItem);

            
          });
          this.util.sortByKey(this.customCategoriesDropdownData, "name", "asc");
          this.setSelectedCategoryDefaults(this._selectedCategoryName);
          
      });
      if (this.dataTransferService.EnvironmentSpecificCustomCategory) {
        this.customCategoryLabel = this.dataTransferService.EnvironmentSpecificCustomCategory;
      } else {
        this.customCategoryLabel = 'CustCat';
      }
     
      this.externalSharePrice = 1.00;
  }

  ngOnDestroy() {
    this.destroyed$.complete();
    if (this.progressTimer)  clearTimeout(this.progressTimer);
  }

  close() {
   this.dialogRef.close();
  }

  checkSecurities() {    
    
    this.securityMasterService.checkSecurityAvailble(this.securitySymb).subscribe((data: any) => {      
      if (data.securityExists && data.securityExists === "true") {
        this.tooltipMessageSucessShow = false;
        this.tooltipMessage = "--Symbol is already in use--";
        this.canNotContinue = true;
        this.setOtherInputsToDisabled(true);
      } else {
        this.tooltipMessageSucessShow = true;
        this.tooltipMessageSucess = "--Symbol is available--";
     //   setTimeout(() => this.tooltipSucessShow.nativeElement.dispatchEvent(new Event('mouseenter')));
        this.setOtherInputsToDisabled(false);
        if (!this.selectedSecurityType || !this.selectedSecurityType.value) {
          this.canNotContinue = true;
        } else {
          this.canNotContinue = false;
        }
      }     
    });
  }

  setOtherInputsToDisabled(isDisabled: boolean) {
    this.isOtherInputsDisable = isDisabled;
    this.securityTypeDropdown.setDisabled(isDisabled);
    this.customCategoriesDropdown.setDisabled(isDisabled);
  }

  onKeyUpChange() {
    this.tooltipMessage = "";
    this.canNotContinue = true;
    this.setOtherInputsToDisabled(true);
    if (this.securitySymb.length !== 0) {
      this.checkAvailability = false;
    } else {
      this.checkAvailability = true;
    }
    
    if (!this.checkIfValidCustomSymbol(this.securitySymb)) {
      this.checkAvailability = true;
      this.tooltipMessage ="Invalid custom symbol entered"; 
    }

    if (this.securitySymb.includes(",") || this.securitySymb.includes("*")) {
      this.checkAvailability = true;
      this.tooltipMessage ="Invalid Security Symbol";
    } 
  }
  private setSelectedCategoryDefaults(value: string) {
    if (this.customCategories && this.customCategories.length > 0) {
      let customCategorySelected = this.customCategoriesDropdownData.find(x => x.name === value);
      this.selectedCustomCategory = customCategorySelected;
    }

}

private getDistinctCategories(categories: ISecurityCustomCategory []) {
  let distinctCategories: ISecurityCustomCategory [] = [];
  if (categories && categories.length > 0) {
      categories.forEach((x: ISecurityCustomCategory) => {
          if (x.custCatName
              && distinctCategories.findIndex(y => x.custCatName === y.custCatName) === -1) {
              distinctCategories.push(x);
          }
      });
  }
  return distinctCategories;
}

  addSecurity(){
    const request = {} as ICreateSecurites;
    request.securitySymbol = this.securitySymb;
    request.customCategoryId = ""+this.selectedCustomCategory.value;
    request.securityDescription = this.securitySymbDesc;
    request.securityType = this.selectedSecurityType.value;
    request.externalSharePrice = this.externalSharePrice;
    this.requestdatas.push(request);

    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.securityMasterService.addNewSecurityProfilesAsync(this.requestdatas).subscribe((response: any) => {
      //this.updateNewSecurityProfilesFinish(response);
      this.updateStatusCount = 0;
      if (this.progressTimer)  clearTimeout(this.progressTimer);
      this.updateStatusCount = 0;
      if (response.responseUtilityMap)
        this.actionStatusCheckIntervalStart(response.responseUtilityMap.statusId);
    });
  }
  updateNewSecurityProfilesFinish(response: any) {
    if(response.responseStatus=== "SUCCESS") {
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: 'success',
        summary: "New Securities",
        detail: response.responseData.length+ " securities added."
      });
      this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
      this.fireIntegrationEvent(response);
    } else if (response.responseStatus === "STALEDATAEXCEPTION") {
      this.refreshRequired();
    } else{
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: 'error',
        summary: "New Securities",
        detail: " An error occurred processing your request."
      });
    }
  }

  private fireIntegrationEvent(response: any) {
    if (this.mdd) {
      let eventData = JSON.parse(JSON.stringify(this.mdd)); // create a deep copy
      eventData.securities = response;
      this.as.fireEvent(IrbModelsEvents.SAVE_CREATE_NEW_SECURITY, eventData);
    }
  }

  refreshRequired(){
    this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
        dTitle: 'Refresh Required',
        dProceedBtnLabel: 'Refresh',
        msg: "You are attempting to create or update securities that was just modified by someone else. To see the updated securities, you need to refresh the page.",
        onProceed: () => {this.as.fireEvent(IrbAppEvents.GRID_REFRESH);}
    } as IAlertDialogData);
  }


  checkIfValidCustomSymbol(unRecognizedSymbol: string){
    let notAllowedSpCharSymbol ;
    let allowedSpCharSymbol ;
    let notAllowedSpCharPattern = /[^~!#a-zA-Z0-9]/g;
    let allowedSpCharPattern = /[~!#]/g;
    if(unRecognizedSymbol.match(notAllowedSpCharPattern) && unRecognizedSymbol.match(notAllowedSpCharPattern) != null)
      notAllowedSpCharSymbol = unRecognizedSymbol.match(notAllowedSpCharPattern);
    if(unRecognizedSymbol.match(allowedSpCharPattern) && unRecognizedSymbol.match(allowedSpCharPattern) != null)
      allowedSpCharSymbol = unRecognizedSymbol.match(allowedSpCharPattern);
    if((notAllowedSpCharSymbol && notAllowedSpCharSymbol.length >0) || (allowedSpCharSymbol && allowedSpCharSymbol.length > 2)) {
      return false;
    } else {
      return true;
    }
  }

  getItemsForSecurityTypeDropdown(searchString: string) {
    if (searchString && searchString.length > 0) {
      this.securityTypeDropdown.set((this.securityTypes || [])
          .filter((item: any) => item.name &&
              item.name.toUpperCase().startsWith(searchString.toUpperCase()))
      );
    } else if(searchString === null || (typeof searchString === "string")) {
      this.securityTypeDropdown.set(this.securityTypes || []);
    }
  }

  onSecurityTypeChanged(event: IDropdownItem) {
    this.selectedSecurityType = event;
    this.canNotContinue = false;
    if (!this.selectedSecurityType.value) {
      this.canNotContinue = true;
    } else {
      this.canNotContinue = false;
    }
    if (this.selectedSecurityType.value === "EXTERNAL"){
      this.isExternalShare = true;
    } else {
      this.isExternalShare = false;
    }
    this.categoryChanged.emit(event);
  }

  getItemsForCustomCategoriesDropdown(searchString: string) {
    if (searchString && searchString.length > 0) {
      this.customCategoriesDropdown.set((this.customCategoriesDropdownData || [])
          .filter((item: any) => item.name &&
              item.name.toUpperCase().startsWith(searchString.toUpperCase()))
      );
    } else if(searchString === null || (typeof searchString === "string")) {
      this.customCategoriesDropdown.set(this.customCategoriesDropdownData || []);
    }
  }

  onCustomCategoryChanged(event: IDropdownItem) {
    this._selectedCategoryName = event.name;
    this.selectedCustomCategory = event;
    this.categoryChanged.emit(event);
  }

  actionStatusCheckIntervalStart(statusId: any) {
    this.securityMasterService.actionStatusCheck(statusId).subscribe((statusResponse: any) => {
      if (statusResponse.responseStatus === "SUCCESS") {

        let reqStatus = 'FAILED';
        if (statusResponse.responseUtilityMap && statusResponse.responseUtilityMap.requestStatus) {
          reqStatus = statusResponse.responseUtilityMap.requestStatus.trim().toUpperCase();
        }

        if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
          let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
          if (this.isUiTest)
            timeout = 0;
          this.updateStatusCount++;
          this.progressTimer = setTimeout(() => {
            this.actionStatusCheckIntervalStart(statusId);
          }, timeout);
        }

        if (reqStatus === 'COMPLETED') {
          if (this.progressTimer) clearTimeout(this.progressTimer);
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          const responseData = JSON.parse(statusResponse.responseData);
          this.updateNewSecurityProfilesFinish(responseData);
          this.close();
        }

        if (reqStatus === 'STALEDATAEXCEPTION') {
          this.close();
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          if (this.progressTimer) clearTimeout(this.progressTimer);
          this.refreshRequired();
        }

        if (reqStatus === 'FAILED') {
          this.actionStatusCheckFailed();
        }
      } else {
        this.actionStatusCheckFailed();
      }
    }, () => {
      this.close();
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      if (this.progressTimer) clearTimeout(this.progressTimer);
    });
  }

  actionStatusCheckFailed() {
    this.close();
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    if (this.progressTimer) clearTimeout(this.progressTimer);
    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
      severity: 'error',
      summary: "Import Security Category",
      detail: " An error occurred processing your request."
    });
  }

}
